<template>
  <div>
    <el-dialog
      :title="info.title"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
      width="600px"
    >
      <el-form>
          <div><span v-html="info.content_th" style="word-break: normal"></span></div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },
  data() {
    return {
      labelPosition: "top",
      show: false,
    };
  },
  created() {
    // document.getElementById("content_th").innerHTML = this.info.content_th
    // console.log('ow')
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    },
    info() {
      // console.log(this.info)
    }
  },
  mounted() {
    // console.log('this')
    // this.info.content_th = this.info.content_th.innerHTML
  },
  props: ["info", "dialog"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
 